import styled from "styled-components";

import { media } from "../../../../styles/media";

export const ServiceTypeAndCapacityFormStyles = styled.div`
  .cardHeaderRow {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  .sectionSaveBtn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    animation: fadeSlideIn 0.25s ease-out;
  }

  .serviceTypesContainer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${({ theme }) => theme.spacing[20]};
    ${media.maxTablet`grid-template-columns: repeat(2, 1fr);`}
    ${media.maxMobile`grid-template-columns: 1fr;`}
  }
`;
